module.exports = __webpack_public_path__ + "img/mtsx02.262ee83c.png";